import { Component, EventEmitter, Output } from "@angular/core";
import './account-settings-save-warning.component.scss';

@Component({
    selector: 'account-settings-save-warning',
    template: require('./account-settings-save-warning.component.html')
})
export class AccountSettingsSaveWarningComponent {

    @Output() response = new EventEmitter<boolean>();

    onConfirmClicked(): void {
        this.response.emit(true);
    }

    onCancelClicked(): void {
        this.response.emit(false);
    }

}
